<template>
<div class="">
<user-top></user-top>
<div class="millia">
<div v-show="ishide" class="blueBg mt30">
<div class="ht tc mt20">确认个人信息</div>
<div class="ht01">基本信息</div>
<ul class="infoList mt20">
<li><label>姓名：</label>{{allData.realname}}</li>
<li><label>照片：</label><img :src="img_url" class="userImg"></li>
<li><label>性别：</label>{{allData.sex_text}}</li>
<li><label>身份证号码：</label>{{allData.id_card}}</li>
<!--<li><label>民族：</label>{{allData.nation_text}}</li>-->
<li><label>出生日期：</label>{{allData.birthday}}</li>
<li><label>政治面貌：</label>{{allData.political_status_text}}</li>
<!--<li><label>身份类型：</label>{{allData.user_type_text}}</li>-->
<li><label>学历：</label>{{allData.education_text}}</li>
<li><label>学位：</label>{{allData.degree_text}}</li>
<li><label>专业：</label>{{allData.major}}</li>
<li><label>毕业学校：</label>{{allData.graduated_school}}</li>
<li><label>毕业时间：</label>{{allData.graduated_time}}</li>
<li><label>工作时间：</label>{{allData.work_time}}</li>
<!--<li><label>工作单位：</label>{{allData.employer}}</li>-->
<li><label>户籍所在地：</label>{{allData.household}}</li>
<!--<li><label>其他说明：</label>{{allData.other}}</li>-->
</ul>
<div class="ht01 mt20">教育经历</div>
<ul class="expList">
<li v-for="(eduLists,id) of eduList" :key="id" :id="eduLists.id">
<p><label>学校名称：</label>{{eduLists.school_name}}</p>
<p><label>所获学历：</label>{{eduLists.education_text}}</p>
<p><label>专业：</label>{{eduLists.major}}</p>
<p><label>开始时间：</label>{{eduLists.start_time}}</p>
<p><label>结束时间：</label>{{eduLists.end_time}}</p>
</li>
</ul>
<div class="ht01 mt20">工作经历</div>
<ul class="expList">
<li v-for="(jobLists,id) of jobList" :key="id" :id="jobLists.id">
<p><label>公司名称：</label>{{jobLists.company_name}}</p>
<p><label>岗位：</label>{{jobLists.position}}</p>
<p><label>开始时间：</label>{{jobLists.start_time}}</p>
<p><label>离职时间：</label>{{jobLists.end_time}}</p>
<p><label>岗位说明：</label>{{jobLists.work_exp}}</p>
</li>
</ul>
<div class="ht01 mt20">家庭关系</div>
<ul class="expList">
<li v-for="(familyLists,id) of familyList" :key="id" :id="familyLists.id">
<p><label>姓名：</label>{{familyLists.realname}}</p>
<p><label>手机号码：</label>{{familyLists.phone}}</p>
<p><label>成员关系：</label>{{familyLists.relation}}</p>
<p><label>工作单位：</label>{{familyLists.work_add}}</p>
</li>
</ul>
</div>
<div class="blueBg mt30 mb30">
<div class="ht tc mt20">职位申请</div>
<!-- <div class="layui-form" > -->
<div v-if="noneApply" class="tc f16 pb20">暂无职位</div>
<div v-if="noneUl">
<form  action="">
<ul class="UserList mt20">
<li v-for="(list,index) in saveApply" :key="list.id">
<label @click="getTxt(index)">
<input id="list.id" name="radio" type="radio" class="a-radio" :value="list.id" v-model="position_id">
<span class="b-radio"></span>
<p><b>{{list.title}}</b>-<b>{{list.dept_name}}</b></p>
</label>
</li>
</ul>
<div class="mt20 pb50"><button type="button" class="layui-btn layui-btn-fluid layui-btn-normal" @click="ApplySelectEndter">确认提交</button></div>
</form>
</div>
</div>
</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop.vue'
export default {
    name:"SaveApply",
    components:{
        UserTop
    },
    data () {
        return {
            saveApply:{},//职位的所有数据,
            position_id:"",//提交数据
            dept_pname:"",//单位名称
            dept_name:"",//部门名称
            title:"",//岗位名称
            ishide:false,//是否申请岗位显示用户所有信息
            allData:{},//用户所有资料
            img_url:"",//用户头像地址
            eduList:[],//教育经历
            jobList:[],//工作经历
            familyList:[],//家庭关系
            noneApply:false, //是否有职位可申请
            noneUl:true, //没有职位隐藏列表
        }
    },
    mounted() {
        this.getAllData();
    },
    updated() {
    },
    methods:{
        //获取岗位ID及部门ID
        GetApply(){
            let url = "api/apply/getPositionData2";
            let params = {}
            this.$ajax.post(url, params).then(function (response) {
            console.log(response.data.data)
                if (response.data.status==1) {
                    this.saveApply = response.data.data;
                    if(this.saveApply.length == 0){
                        console.log("没有职位");
                        this.noneApply = true;
                        this.noneUl = false;
                    }
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        //获取radio文字
        getTxt(index){
            this.dept_pname = this.saveApply[index].dept_pname;//单位名称
            this.dept_name = this.saveApply[index].dept_name;//部门名称
            this.title = this.saveApply[index].title;//岗位名称
        },
        //选择岗位提交
        ApplySelectEndter() {
            if (this.position_id == '') {
                layer.alert("请至少选择一个岗位！");
                return false;
            }
            var that = this;
            layui.use('layer', function(){
                var $ = layui.$;
                var layer = layui.layer;
                var locked = false;//默认未锁定
                layer.confirm("您申报的岗位为："+"<b style='color:#FF5722'>  "+" "+that.dept_name+" "+that.title+"</b>　确定提交吗？", {
                    btn: ['确定提交','再想想'] //按钮
                }, function(){
                    //console.log(locked);
                    if(!locked){
                        locked = true;//锁定
                        //console.log(locked);
                        var params = {
                            position_id:that.position_id
                        };
                        //console.log(params);
                        let url = "api/apply/saveApply2";
                        that.$ajax.post(url,params).then(function (response) {
                            if (response.data.status==1) {
                                layer.alert("岗位申请提交成功");
                                that.$router.push("/UserInfo");
                            }else{
                                layer.alert(response.data.info);
                            }
                            if (response.data.status==-2) {
                                layer.alert(response.data.info);
                            }
                        }.bind(this)).catch(function (err) {
                            console.log("连接失败");
                        }.bind(this));

                    }
                    //layer.close(myconfirm);
                }, function(){
                    layer.alert("已取消,并未申报");

                });
            });
        },

        //获取用户所有信息
        getAllData() {
            let url = "api/user/getUserInfo";
            let params = {}
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.allData = response.data.data;
                    this.img_url = response.data.data.img_url;
                    this.eduList = response.data.data.edu_exp;
                    this.jobList = response.data.data.work_exp;
                    this.familyList = response.data.data.family;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        //点击下载pdf文件
        downLoadFiles(){
            window.open(this.pdf_url);
        }
    },
    beforeMount() {
        this.GetApply();
	},
    watch:{
        //检测用户是否已填用户信息和教育经历
        allData(){
            if (JSON.stringify(this.allData) === "[]") {
                layer.alert("请先完善个人资料！");
                this.$router.push('/BasicInfo');
            }else if(JSON.stringify(this.eduList) === "[]"){
                layer.alert("请先完善教育经历！");
                this.$router.push('/EduExp');
            }else if(JSON.stringify(this.familyList) === "[]"){
                layer.alert("请先完善家庭关系！");
                this.$router.push('/FamilyGroup');
            }else{
                this.ishide = true;
            }
        },

    },
}
</script>
<style scoped>
.ht01{font-size:1.5rem;padding:1rem 0;color:#3fa6e3;border-bottom:.1rem solid #99D3F5;font-weight:bold;}
.blueBg{padding-bottom:1rem;font-size:1.4rem;color:#333;background:#D0EEFF;border:.1rem solid #99D3F5;border-radius:1rem;padding:1.5rem;}
.infoList li{padding-bottom:1rem;font-size:1.4rem;color:#333;}
.infoList li label,.expList li p label{display:inline-block;padding-right:1rem;font-size:1.4rem;color:#3fa6e3;font-weight:normal;}
.expList li{border-bottom:.1rem dotted #d0d0d0;font-size:1.4rem;color:#333;position:relative;margin-bottom:0;padding:1.5rem 0 0 0;}
.expList li:last-child{border:none;}
.expList li p{padding-bottom:1rem;}
.UserList li{position:relative;display:block;font-size:1.4rem;margin-bottom:1.5rem}
.UserList li label{display:flex;align-items:flex-start;}
.UserList li label span{margin-top:0.3rem;}
.UserList li b{font-weight:normal;display:inline-block;margin:0 .5rem;}
.a-radio{display:none;}
.b-radio{display:inline-block;border:.1rem solid #ccc;width:1.4rem;height:1.4rem;border-radius:1rem;vertical-align:middle;margin-right:1rem;position:relative;}
.b-radio:before{content:"";font-size:0;width:1rem;height:1rem;background:#1E9FFF;position:absolute;left:50%;top:50%;margin:-0.5rem 0 0 -0.5rem;border-radius:2rem;display:none;}
.a-radio:checked~.b-radio:before{display:block;}
.userImg{width:10rem;height:auto;border:1px solid #3fa6e3;}
</style>